import React from "react";
import { useAppDispatch } from "../app/hooks";
import { resetConsent } from "../features/consent/consentSlice";
import { useNavigate } from "react-router-dom";
import Card from "../components/ui/Card";
import Button from "../components/ui/Button";

const ConsentDeny: React.FC = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    React.useEffect(() => {
        import("../utils/androidBridge").then(({ notifySdkConsentError }) => {
            notifySdkConsentError("User denied consent");
        });
    }, []);

    const handleRetry = () => {
        dispatch(resetConsent());
        navigate("/consentDetails");
    };

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-fin-bg p-6">
            <Card className="max-w-md w-full text-center py-10 bg-fin-surface border-fin-border">
                <div className="mx-auto h-16 w-16 bg-red-900/20 border border-red-900/30 rounded-full flex items-center justify-center mb-6">
                    <svg className="h-8 w-8 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </div>

                <h1 className="text-2xl font-bold text-white mb-2">Consent Status</h1>
                <p className="text-fin-slate mb-10 max-w-xs mx-auto text-sm leading-relaxed">
                    You have chosen not to provide consent. Your financial data will remain private and won't be shared.
                </p>

                <div className="space-y-3 px-2">
                    <Button
                        variant="primary"
                        fullWidth
                        onClick={() => navigate("/login")}
                        className="py-3.5"
                    >
                        Return to Login
                    </Button>
                    <Button
                        variant="ghost"
                        fullWidth
                        onClick={handleRetry}
                        className="text-fin-slate hover:text-white"
                    >
                        Review Request Again
                    </Button>
                </div>
            </Card>
        </div>
    );
};

export default ConsentDeny;
